import { api } from '../../shared/api/client';

export interface Slot {
  id: string;
  description: string;
  date: string;
  timeWindow: string;
  status: 'open' | 'claimed';
}

export async function fetchOpenSlots(): Promise<Slot[]> {
  return api.get<Slot[]>('/api/v1/slots/open');
}
